import { Text } from '@tribeplatform/react-ui-kit/Text'

import { BC } from '../../types/index.js'
import { MarkdownBlock } from '../Markdown/Block.js'
import { TextProps } from './types.js'

export const TextBlock: BC<TextProps> = ({
  value,
  size,
  align,
  truncate,
  format,
  ...rest
}) => {
  return (
    <Text size={size} align={align} truncate={truncate} {...rest}>
      {format === 'markdown' ? <MarkdownBlock text={value} /> : value}
    </Text>
  )
}
